import { createAsyncThunk } from "@reduxjs/toolkit";
import campaignApi from "api/campaignApi";
import { formatQueryParams } from "helpers/format";

export const getCampaigns = createAsyncThunk("Campaigns", async (params: any = {}) => {
  try {
    const response: any = await campaignApi.campaigns(formatQueryParams(params));
    const data = (response?.data || [])?.filter((item: any) => (params?.status === '' || item?.status === params?.status))?.filter((item: any) => (params?.type === '' || item?.command === String(params?.type)))?.filter((item: any) => (params?.pool === '' || item?.trade_config?.target_pool === String(params?.pool)))?.filter((item: any) => (params?.wallet === '' || item?.public_key === String(params?.wallet)));
    return ({ data });
  } catch (error) {
    return error;
  }
});

export const getCampaign = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getCampaign(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getAssetCampaign = async (id: string | number, params: any = {}) => {
  try {
    const response = await campaignApi.getAssetCampaign(id, params)
    return response;
  } catch (error) {
    return error;
  }
};


export const postCampaign = async (data: any = {}) => {
  try {
    const response = await campaignApi.postCampaign(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCampaign = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.putCampaign(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteCampaign = async (id: string | number, data: any = {}) => {
  try {
    const response = await campaignApi.deleteCampaign(id, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const runCampaign = async (id: string | number = '') => {
  try {
    const response = await campaignApi.runCampaign(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const stopCampaign = async (id: string | number = '') => {
  try {
    const response = await campaignApi.stopCampaign(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const getCampaignLogs = async (params: any = {}) => {
  try {
    const response = await campaignApi.getCampaignLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


export const updateBootingConfigCampaign = async (id: string | number = '', data: any = {}) => {
  try {
    const response = await campaignApi.updateBootingConfigCampaign(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateFundingCampaign = async (data: any = {}) => {
  try {
    const response = await campaignApi.updateFundingCampaign(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateAllocationCampaign = async (data: any = {}) => {
  try {
    const response = await campaignApi.updateAllocationCampaign(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getListExistedPool = async (params: any = {}) => {
  try {
    const response = await campaignApi.getListExistedPool(params);
    return response;
  } catch (error) {
    return error;
  }
};

export const getListAvailableFeeTier = async (params: any = {}) => {
  try {
    const response = await campaignApi.getListAvailableFeeTier(params);
    return response;
  } catch (error) {
    return error;
  }
};